import { ContentChildren, Directive, ElementRef, EventEmitter, forwardRef, Input, Output, QueryList } from '@angular/core';
import { CsRadioBase } from 'components/cs-radio/cs-radio-component-interface';

@Directive({
    selector: '[cs-radio-group]',
    // the radios inside are announced as one set of choices
    host: { 'role': 'radiogroup' },
    standalone: false
})
export class RadioGroupDirective {

  @ContentChildren(forwardRef(() => CsRadioBase), { descendants: true }) items: QueryList<CsRadioBase>;

  @Input() selected: any;
  @Output() selectedChange = new EventEmitter<any>();

  constructor(public elementRef: ElementRef) {
  }

  deselectAll() {
    this.items.forEach(item => item.deselect());
  }

  select(value: any) {
    if (value !== this.selected) {
      this.selected = value;
      this.selectedChange.emit(value);
    }
  }

}
